import React from 'react';
import classNames from 'classnames';

const Video = ({ className }) => {
	return (
		<div className={classNames(className, 'dataWrapper')}>
			here comes video?
		</div>
	);
};

export default Video;
